import { useEffect } from 'react';
import { useSaveSearchContext } from 'shared/common/packages/SaveSearchModal';

/**
 * Подписывается на событие открытие модально окна СП
 */
export const useSaveSearchModal = () => {
  const { onOpen } = useSaveSearchContext();

  useEffect(() => {
    addEventListener('saveSearchButton:clicked', onOpen);

    return () => {
      removeEventListener('saveSearchButton:clicked', onOpen);
    };
  }, [onOpen]);
};
